import { parseExpressFullOdds } from "./parseFullOdds";
import { parseTopNOdds } from "./parseTopNOdds";
import { parseBankerOdds } from "./parseBankerOdds";
import{ parseExprWPQBanker}  from "./parseWPQBanker";
import{ parseExprWPQTop }  from "./parseWPQTop";

export const parseExpressOdds = ( content, message, topicInfo) => {
    let idaPushComingleRaces = []
    if(window.globalConfig.EXPRESS_OB_IDA_PUSH && !['WIN', 'PLA'].includes(topicInfo.oddsType)){
        idaPushComingleRaces = content.meeting?.obSt?.reduce((array, data) => {
            if(data.comingleStatus == "1" || data.comingleStatus == "2"){
                if(!array.includes(data.leg.races[0])){
                    array.push(data.leg.races[0])
                }
            }
            return array
        },[])
    }
    let pmPool,
        poolInv;
    switch (topicInfo.displayType) {
        case "full":
            pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType && x.leg.races[0]===topicInfo.raceNo)[0];
            poolInv = content.meeting.poolInvs.find(x => x.oddsType===topicInfo.oddsType && x.leg.races[0]===topicInfo.raceNo);
            if(pmPool!=null){
                parseExpressFullOdds(pmPool,message)
            }
            if(poolInv != null){
                let investment
                if(message?.pRfd) {
                    investment = 0
                }else{
                    investment = message?.pInv || poolInv.investment
                }
                poolInv.lastUpdateTime = message.updAt
                if(!idaPushComingleRaces.includes(topicInfo.raceNo)){
                    poolInv.investment = investment
                }
            }
            //  [WIP]  WPQ page
            if(content.page == "WPQ"){    
                let topPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType +"Top" && x.leg.races[0]===topicInfo.raceNo)[0]; //parseTop20
                if(topPool!=null){
                    parseExprWPQTop(topPool,message)
                }
                let bankerPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType +"Banker" && x.leg.races[0]===topicInfo.raceNo)[0]; //parse Banker
                if(bankerPool!=null){
                    parseExprWPQBanker(content.meeting, bankerPool,message)
                }
            }
            break;
        case "top_n":
            // pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType + "Top" && x.leg.races[0]===topicInfo.raceNo)[0];
            // if(pmPool!=null){
            //     parseTopNOdds(pmPool,message)
            // }
            break;
        case "banker":
            // pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType + "Banker" && x.leg.races[0]===topicInfo.raceNo)[0];
            // if(pmPool!=null){
            //     parseBankerOdds(pmPool,message)
            // }
            break;
    }
}